module.exports = "https://r.zoocdn.com/_next/static/images/erasure-256a1160cb571c327eb57f8a878ea113.svg";